import React, { useState, useEffect } from "react";
import Title from "../../../../../components/Title";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import RlCloudSandboxProcessTree from "./RlCloudSandboxProcessTree";
import RlCloudSandboxBehavioralTabs from "./RlCloudSandboxBehavioralTabs";
import {
  Behavioral,
  BehavioralProcess,
  ProcessTree
} from "../../../@types/rldynamicanalysis";

type RlCloudSandboxBehavioralProps = {
  mergedReportActive: boolean;
  latestReportReady: boolean;
  behavioralData: Behavioral[];
  processTreeData: ProcessTree[];
  reportTitle: string;
};

const RlCloudSandboxBehavioral = ({
  mergedReportActive,
  latestReportReady,
  behavioralData,
  processTreeData = [],
  reportTitle
}: RlCloudSandboxBehavioralProps) => {
  const [currentProcessTreeItem, setCurrentProcessTreeItem] =
    useState<BehavioralProcess | null>(null);
  const [dataForCurrentProcess, setDataforCurrentProcess] =
    useState<Behavioral | null>(null);

  const filterDataByProcess = (data: Behavioral[]) => {
    const gridData = data.filter(
      ({ process }) =>
        process?.name === currentProcessTreeItem?.name &&
        process?.parameters === currentProcessTreeItem?.parameters
    )[0];
    setDataforCurrentProcess(gridData);
  };

  useEffect(() => {
    if (processTreeData.length < 1) return;
    const { name, parameters, process_id } = processTreeData[0];
    setCurrentProcessTreeItem({ name, parameters, process_id });
  }, [processTreeData]);

  useEffect(() => {
    if (!currentProcessTreeItem) return;
    filterDataByProcess(behavioralData);
  }, [currentProcessTreeItem]);

  const displayWhenNoData =
    mergedReportActive && !latestReportReady ? (
      <div className="relative">
        <LoadingOverlay />
      </div>
    ) : (
      <b>Behavioral Data Doesn&apos;t Exist for This Analysis.</b>
    );

  return (
    <>
      <Title
        Level="h2"
        text={`Behavioral Analysis ${
          mergedReportActive ? "(Latest Report)" : `(${reportTitle})`
        }`}
      />
      {behavioralData ? (
        <>
          <RlCloudSandboxProcessTree
            data={processTreeData}
            activeItem={currentProcessTreeItem}
            setActiveItem={setCurrentProcessTreeItem}
          />
          <RlCloudSandboxBehavioralTabs data={dataForCurrentProcess} />
        </>
      ) : (
        displayWhenNoData
      )}
    </>
  );
};

export default RlCloudSandboxBehavioral;
